<div class="assessment-container">
  <assessment-row title="Extremity Movement" [historyMode]="true">
    <p>{{ data().extremityMovement }}</p>
  </assessment-row>
  <assessment-row title="Hand Grips" [historyMode]="true">
    <p>{{ data().handGrips }}</p>
  </assessment-row>
  <assessment-row title="LE Push/Pull" [historyMode]="true">
    <p>{{ data().lePushPull }}</p>
  </assessment-row>
  <assessment-row title="Glasgow Coma Scale Score" [historyMode]="true">
    <p>{{ data().gcss }}</p>
  </assessment-row>

  <h2>Sensation</h2>
  <assessment-row title="RUE" [historyMode]="true">
    <p>{{ data().sensationRue }}</p>
  </assessment-row>
  <assessment-row title="RLE" [historyMode]="true">
    <p>{{ data().sensationRle }}</p>
  </assessment-row>
  <assessment-row title="LLE" [historyMode]="true">
    <p>{{ data().sensationLle }}</p>
  </assessment-row>
  <assessment-row title="LUE" [historyMode]="true">
    <p>{{ data().sensationLue }}</p>
  </assessment-row>

  <assessment-row title="Tremors" [historyMode]="true">
    <emr-list [list]="data().tremors" emptyText="None"></emr-list>
  </assessment-row>

  @if (patient().isObstetric()) {
  @if (data().isEpidural) {
  <h2>Epidural</h2>
  <assessment-row title="Level of Sensory Block" [historyMode]="true">
    <p>{{ data().sensoryBlockLevel }}</p>
  </assessment-row>
  }
  <assessment-row title="Abnormal Reflexes Noted" [historyMode]="true">
    <p>{{ data().abnormalReflexesNoted }}</p>
  </assessment-row>
  }

  @if (patient().isPediatric()) {
  <assessment-row title="Abnormal Reflexes" [historyMode]="true">
    <p>{{ data().abnormalReflexesPresent ? 'Yes' : 'No' }}</p>
  </assessment-row>
  @if (data().abnormalReflexesPresent) {
  <assessment-row title="Abnormal Reflex Type" [historyMode]="true">
    <p>{{ data().abnormalReflexesType }}</p>
  </assessment-row>
  <assessment-row title="Abnormal Reflex Details" [historyMode]="true">
    <p>{{ data().abnormalReflexesDetails }}</p>
  </assessment-row>
  }
  }

  <assessment-row title="Other Findings" [historyMode]="true">
    <p>{{ data().otherFindings }}</p>
  </assessment-row>
</div>